// ============================================================
// DATA FILE — Edit this file to update your portfolio content
// ============================================================

export const personalInfo = {
  name: "Made Marshall Vira Deva",
  shortName: "MARSHALLVD",
  title: "AI Engineer & Software Developer",
  subtitle: "Machine Learning · LLM Evaluation · Web Development",
  tagline: "Building intelligent systems at the intersection of AI and software engineering.",
  email: "mademarshall97@gmail.com",
  phone: "+6285155426099",
  whatsapp: "+6285155426099",
  location: "Denpasar Timur, Bali, Indonesia",
  linkedin: "https://www.linkedin.com/in/marshallvd/",
  github: "https://github.com/marshallvd",
  instagram: "https://www.instagram.com/marshallvd/",
  transcriptDrive: "https://drive.google.com/your-transcript-link-here",
  gpa: "3.86",
  status: "Open to Opportunities",
};

export const stats = [
  { num: "3.86", label: "GPA Score" },
  { num: "2+", label: "Years Experience" },
  { num: "15+", label: "Projects Built" },
  { num: "20+", label: "Certifications" },
];

export const experiences = [
  {
    period: "Jun 2025 — Present",
    role: "Web Developer & Digital Marketing",
    company: "Dewanta Villas Management · Gianyar, Bali",
    type: "Full-time",
    desc: [
      "Designing and developing a full-featured website with modern UI/UX principles, responsive design, SEO best practices, and integrated booking functionality.",
      "Created and managed engaging social media content for Instagram and Facebook, driving engagement and booking interest.",
      "Executed targeted Facebook Ads campaigns with strategic audience segmentation, generating qualified leads for villa bookings.",
      "Bridged marketing and technology by aligning social media, paid advertising, and web platform into a seamless brand experience.",
    ],
    tags: ["React", "Laravel", "Digital Marketing", "Facebook Ads", "SEO"],
  },
  {
    period: "Dec 2025 — Present",
    role: "AI QA Trainer — LLM Evaluation Specialist",
    company: "Invisible Technologies · Remote",
    type: "Project-based",
    desc: [
      "Approved member of the Invisible Expert Network specializing in AI Quality Assurance and Large Language Model (LLM) Evaluation.",
      "Part of a global network of experts training and evaluating cutting-edge AI systems to meet rigorous standards of accuracy, relevance, and safety.",
      "Focused on improving AI performance through systematic assessment and feedback of model outputs.",
      "Collaborate with leading technology clients on LLM training, quality assurance, and AI model evaluation projects.",
    ],
    tags: ["LLM Evaluation", "AI QA", "Prompt Engineering", "Data Labeling"],
  },
];

export const organizations = [
  {
    period: "Jan 2023 — Dec 2023",
    role: "Head of Science Division",
    company: "Himpunan Mahasiswa Teknologi Informasi · Jimbaran, Bali",
    desc: [
      "Managed three divisions: Scientific Competitions, Practical Work, and Exhibitions.",
      "Oversaw a total of 16 members, coordinating activities and ensuring effective collaboration.",
      "Organized and facilitated events to promote academic excellence and practical skills.",
    ],
    tags: ["Leadership", "Event Management", "Team Coordination"],
  },
  {
    period: "Mar 2023 — Jun 2023",
    role: "Lab Assistant — Database Concepts Practicum",
    company: "Universitas Udayana · Jimbaran, Bali",
    desc: [
      "Supervised 6 students taking the Database Concepts Practicum course.",
      "Taught Entity Relationship Diagrams (ERD), Physical Data Models (PDM), and basic SQL queries.",
    ],
    tags: ["SQL", "ERD", "Teaching", "Database"],
  },
  {
    period: "Jan 2022 — Dec 2022",
    role: "Member of Finance Division",
    company: "Engineering Technopreneur Community · Jimbaran, Bali",
    desc: [
      "Planned financial activities based on the work plan.",
      "Created and maintained cash flow reports, budget plans (RAB), and profit and loss statements.",
    ],
    tags: ["Financial Planning", "Budgeting", "Reporting"],
  },
];

export const education = [
  {
    period: "Sep 2025 — Sep 2027 (Expected)",
    degree: "Master of Information Systems",
    school: "Telkom University · Bandung, Jawa Barat",
    gpa: null,
    icon: "🎓",
    highlight: true,
  },
  {
    period: "Sep 2021 — Jun 2025",
    degree: "Bachelor of Information Technology",
    school: "Universitas Udayana · Jimbaran, Bali",
    gpa: "3.86 / 4.00",
    icon: "🏛️",
    highlight: false,
  },
  {
    period: "Mar 2024 — Aug 2024",
    degree: "Machine Learning Cohort",
    school: "Bangkit Academy by Google, Tokopedia, Gojek & Traveloka",
    gpa: "Distinction Graduate",
    icon: "🤖",
    highlight: false,
    note: "Developed ML model for detection of 20 types of Indonesian batik",
  },
];

export const certifications = [
  // ── BANGKIT ──
  {
    name: "Bangkit Academy 2023 - Distinction Graduate",
    issuer: "Bangkit Academy (Google, Tokopedia, Gojek, Traveloka)",
    year: "2023",
    icon: "🏆",
    color: "#f59e0b",
    link: "https://drive.google.com/file/d/156NK0pFtEcO051kMr38J4KBG1ukWWXLY/view?usp=sharing",
  },

  // ── TENSORFLOW ──
  {
    name: "TensorFlow Developer Certificate",
    issuer: "TensorFlow Certificate Program",
    year: "2024",
    icon: "🧠",
    color: "#FF6F00",
    link: "https://drive.google.com/file/d/1towZt7mCOvmhgRNI2Jxb3FYu-mT7Q0Gn/view?usp=sharing",
  },

  // ── GOOGLE / COURSERA ──
  {
    name: "Google Data Analytics Professional Certificate",
    issuer: "Google · Coursera",
    year: "2023",
    icon: "📊",
    color: "#4285F4",
    link: "https://drive.google.com/drive/folders/1U4m0_NndbWaxONwcgmzFxUg4kC16MNDA?usp=sharing",
  },
  {
    name: "Google IT Automation with Python",
    issuer: "Google · Coursera",
    year: "2023",
    icon: "⚙️",
    color: "#4285F4",
    link: "https://drive.google.com/drive/folders/14PoTXXOHMFdScW58zc2wbfYOr2RnqClK?usp=sharing",
  },

  // ── DEEPLEARNING.AI / COURSERA ──
  {
    name: "Machine Learning Specialization",
    issuer: "DeepLearning.AI · Coursera",
    year: "2023",
    icon: "🤖",
    color: "#7b2fff",
    link: "https://drive.google.com/drive/folders/1DWjCNIM250dqUwTBMTqhqhoo01cqCssX?usp=sharing",
  },
  {
    name: "Mathematics for Machine Learning",
    issuer: "DeepLearning.AI · Coursera",
    year: "2023",
    icon: "📐",
    color: "#7b2fff",
    link: "https://drive.google.com/drive/folders/1DLa9He20GTKymQSxXNkj1kRD7NpELAAy?usp=sharing",
  },
  {
    name: "Structuring Machine Learning Projects",
    issuer: "DeepLearning.AI · Coursera",
    year: "2023",
    icon: "🗂️",
    color: "#7b2fff",
    link: "https://drive.google.com/drive/folders/1PEeYuizwUQMxnhcnBjacwb8UVGSnmjm-?usp=sharing",
  },
  {
    name: "TensorFlow: Data and Deployment",
    issuer: "DeepLearning.AI · Coursera",
    year: "2024",
    icon: "🚀",
    color: "#7b2fff",
    link: "https://drive.google.com/drive/folders/10uLf3vyHk5Goa8PZGKd4-cHZktwZ206N?usp=sharing",
  },
  {
    name: "TensorFlow Developer Specialization",
    issuer: "DeepLearning.AI · Coursera",
    year: "2024",
    icon: "🔬",
    color: "#7b2fff",
    link: "https://drive.google.com/drive/folders/1g9JV2aDcqGjhMzL2H2tJQdJn1rxH4nEB?usp=sharing",
  },

  // ── DICODING ──
  {
    name: "Belajar Dasar Data Science",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "📈",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1oCFO-HuyGWfNsxAiBcwAv-XWsyj4nhd-/view?usp=sharing",
  },
  {
    name: "Belajar Dasar SQL",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🗄️",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/16cCtypTLizcgrwxDIv6S6_ONW0EVJNFI/view?usp=drive_link",
  },
  {
    name: "Memulai Dasar Pemrograman untuk Pengembang Software",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "💻",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1v7-AMxbkBwOMD4h9dSOjBXnIRxaquFHu/view?usp=drive_link",
  },
  {
    name: "Pengenalan ke Logika Pemrograman (Programming Logic 101)",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🔢",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1LinHh6kWFlRROMgHjuL_ArKaPnOh4S-0/view?usp=drive_link",
  },
  {
    name: "Belajar Dasar Git dengan GitHub",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🔀",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1HOa-J6BFE8mPBl3ubUXhsg6hL_Fo5Swr/view?usp=drive_link",
  },
  {
    name: "Memulai Pemrograman dengan Java",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "☕",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1bRSDdr5k08UKrGl-u2aG_CS5fwGzs7ud/view?usp=drive_link",
  },
  {
    name: "Memulai Pemrograman dengan Python",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🐍",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1SfKw6yJaL6tYdpQJHxfxTKoiH99Z_kXF/view?usp=drive_link",
  },
  {
    name: "Belajar Machine Learning untuk Pemula",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🎓",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/15wxT5MhSQt6pMa-dfCadceSSfNR1CYnm/view?usp=drive_link",
  },
  {
    name: "Belajar Dasar AI",
    issuer: "Dicoding Indonesia",
    year: "2023",
    icon: "🧬",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1d25gY7QVrSvRYQR9hDsenRCKA3zRogAu/view?usp=drive_link",
  },
  {
    name: "Membangun Aplikasi Gen AI dengan Microsoft Azure",
    issuer: "Dicoding Indonesia",
    year: "2024",
    icon: "☁️",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1ZfO_IYkABvLbtehmqOld3xobmH_DGoMB/view?usp=drive_link",
  },
  {
    name: "Belajar Penerapan Data Science dengan Microsoft Fabric",
    issuer: "Dicoding Indonesia",
    year: "2024",
    icon: "🔷",
    color: "#00ff88",
    link: "https://drive.google.com/file/d/1owhe6hAtmXjZWFLTY-WJVGymVQe0kjMP/view?usp=drive_link",
  },
];

export const skills = [
  {
    icon: "🤖",
    name: "Machine Learning & AI",
    desc: "Building and evaluating ML models. Specialized in LLM evaluation, AI QA, and deep learning with TensorFlow.",
    tags: ["Python", "TensorFlow", "Scikit-learn", "LLM", "Data Analysis"],
  },
  {
    icon: "🌐",
    name: "Web Development",
    desc: "Full-stack web development with modern frameworks. Clean code, responsive design, SEO-ready.",
    tags: ["React", "Laravel", "PHP", "JavaScript", "HTML/CSS"],
  },
  {
    icon: "📊",
    name: "Data Science",
    desc: "End-to-end data pipelines, visualization, and analysis for actionable business insights.",
    tags: ["Python", "Pandas", "Matplotlib", "SQL", "Data Viz"],
  },
  {
    icon: "🔒",
    name: "Quality Assurance",
    desc: "Manual and automation testing, AI model evaluation, and quality standard enforcement.",
    tags: ["AI Evaluation", "Test Automation", "QA", "Prompt Testing"],
  },
  {
    icon: "🗄️",
    name: "Database & Backend",
    desc: "Database design, query optimization, and backend architecture using SQL and modern tools.",
    tags: ["MySQL", "SQL", "Laravel", "ERD", "PDM"],
  },
  {
    icon: "🎨",
    name: "Design & Marketing",
    desc: "UI/UX design, digital marketing, social media content, and paid advertising campaigns.",
    tags: ["Figma", "Canva", "Facebook Ads", "SEO", "Photoshop"],
  },
];

// ============================================================
// PROJECTS — Fill in your own projects here
// To add a project: copy a block and update the fields
// image: put your image path in /public/images/projects/
// ============================================================

export const projects = [
  // ── WEB DEVELOPMENT ──
  {
    id: 1,
    category: "Web Development",
    name: "HRMS - Human Resource Management System",
    desc: "Thesis project in collaboration with a bank in Bali. Covers features including Master Data, Authentication, Employee Management, Payroll, Performance Appraisal, Leave Management, Recruitment, and Reports.",
    image: null,
    imagePlaceholder: "🏦",
    tools: ["Laravel Blade", "MySQL", "Tailwind CSS"],
    github: "#",
    demo: "#",
    featured: true,
  },
  {
    id: 2,
    category: "Web Development",
    name: "Company Profile - Dewanta Villas Management",
    desc: "More than just a landing page — built with a Content Management System so the owner can manage content independently, integrated with WhatsApp chat for booking inquiries.",
    image: null,
    imagePlaceholder: "🏖️",
    tools: ["React.js", "Node.js", "MySQL"],
    github: "#",
    demo: "#",
    featured: true,
  },
  {
    id: 3,
    category: "Web Development",
    name: "Owner Dashboard - Dewanta Villas Management",
    desc: "A dedicated dashboard for property owners to monitor and track their properties managed by Dewanta Villas Management, emphasizing transparency to build owner trust.",
    image: null,
    imagePlaceholder: "🏡",
    tools: ["React.js", "Laravel", "MySQL"],
    github: "#",
    demo: "#",
    featured: false,
  },

  // ── DIGITAL MARKETING ──
  {
    id: 4,
    category: "Digital Marketing",
    name: "Social Media Management - Dewanta Villas Management",
    desc: "Managed Instagram and Facebook content for Dewanta Villas Management and ran Meta Ads campaigns with strategic audience segmentation to generate qualified villa booking leads.",
    image: null,
    imagePlaceholder: "📱",
    tools: ["Instagram", "Facebook", "Meta Ads", "Content Creation", "Audience Segmentation"],
    github: null,
    demo: "#",
    featured: false,
  },

  // ── MACHINE LEARNING ──
  {
    id: 5,
    category: "Machine Learning",
    name: "Batik Pattern Recognition",
    desc: "A machine learning model deployed to a mobile application using Transfer Learning to detect 20 types of traditional Indonesian batik patterns.",
    image: null,
    imagePlaceholder: "🎨",
    tools: ["Python", "TensorFlow", "Transfer Learning", "Scikit-learn", "Image Classification"],
    github: "#",
    demo: "#",
    featured: true,
  },
  {
    id: 6,
    category: "Machine Learning",
    name: "Ensemble Learning - Bali House Price Prediction",
    desc: "Combined three algorithms — Linear Regression, Random Forest, and XGBoost — into an ensemble model to improve the accuracy of house price predictions in Bali.",
    image: null,
    imagePlaceholder: "🏠",
    tools: ["Python", "Google Colab", "XGBoost", "Random Forest", "Linear Regression"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 7,
    category: "Machine Learning",
    name: "Fake Hotel Booking Detection",
    desc: "Compared Random Forest and XGBoost algorithms to predict whether a hotel booking will be cancelled based on booking patterns.",
    image: null,
    imagePlaceholder: "🏨",
    tools: ["Python", "Random Forest", "XGBoost", "Google Colab"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 8,
    category: "Machine Learning",
    name: "ChilliCare - Chili Leaf Disease Detection",
    desc: "Master's thesis project using Ensemble Learning with InceptionV3, MobileNetV2, and DenseNet121 to detect diseases on chili leaves, deployed to the ChilliCare mobile app with a Gemini API chatbot.",
    image: null,
    imagePlaceholder: "🌶️",
    tools: ["Python", "InceptionV3", "MobileNetV2", "DenseNet121", "Gemini API", "Mobile App"],
    github: "#",
    demo: "#",
    featured: true,
  },
  {
    id: 9,
    category: "Machine Learning",
    name: "Vehicle Detection & Speed Estimation via CCTV",
    desc: "Real-time detection of vehicle count and speed using CCTV footage powered by YOLOv8.",
    image: null,
    imagePlaceholder: "📹",
    tools: ["Python", "YOLOv8", "Computer Vision", "OpenCV"],
    github: "#",
    demo: "#",
    featured: false,
  },

  // ── DATA SCIENCE ──
  {
    id: 10,
    category: "Data Science",
    name: "Sentiment Analysis - Presidential Debate (Prabowo Subianto)",
    desc: "Scraped social media data and performed sentiment analysis on public opinion regarding the Prabowo Subianto presidential debate.",
    image: null,
    imagePlaceholder: "🗳️",
    tools: ["Python", "Google Colab", "Web Scraping", "NLP", "Sentiment Analysis"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 11,
    category: "Data Science",
    name: "Adidas Sales Forecasting - Prophet Algorithm",
    desc: "Forecasted Adidas sales using the Prophet algorithm and visualized the results through Looker Studio for clear business insights.",
    image: null,
    imagePlaceholder: "👟",
    tools: ["Python", "Prophet", "Google Colab", "Looker Studio"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 12,
    category: "Data Science",
    name: "Adidas Sales Analysis - Linear Regression",
    desc: "Analyzed and predicted Adidas sales using a Kaggle dataset as part of a university coursework assignment.",
    image: null,
    imagePlaceholder: "📊",
    tools: ["Python", "Google Colab", "Linear Regression", "Kaggle"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 13,
    category: "Data Science",
    name: "Indonesian Stock News Sentiment Analysis",
    desc: "Built a sentiment analysis model for Indonesian stock market news, deployed directly to a stock news website.",
    image: null,
    imagePlaceholder: "📈",
    tools: ["Python", "NLP", "Sentiment Analysis", "Model Deployment"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 14,
    category: "Data Science",
    name: "Data Quality Monitoring - MBG News (DQMF)",
    desc: "Implemented a Data Quality Management Framework to monitor the quality of MBG news data using Soda Core and DQOps.",
    image: null,
    imagePlaceholder: "🔍",
    tools: ["Python", "Soda Core", "DQOps", "Data Quality"],
    github: "#",
    demo: "#",
    featured: false,
  },
  {
    id: 15,
    category: "Data Science",
    name: "E-Wallet Sentiment Analysis in Indonesia",
    desc: "Built a sentiment analysis model for each e-wallet platform available in Indonesia, analyzing user perceptions and opinions toward each platform based on reviews and social media data.",
    image: null,
    imagePlaceholder: "💳",
    tools: ["Python", "NLP", "Sentiment Analysis", "Google Colab", "Web Scraping"],
    github: "#",
    demo: "#",
    featured: false,
  },
];

export const navLinks = [
  { label: "About",      href: "#about" },
  { label: "Skills",     href: "#skills" },
  { label: "Projects",   href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Education",  href: "#education" },
  { label: "Gallery",    href: "#collage" },
  { label: "Contact",    href: "#contact" },
];
